import axios from 'axios';

// Set the base URL for all axios requests
const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/[/]+$/, '').replace(/[/]api$/, ''); // bare origin; callers prefix /api

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Add request interceptor to include token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Skip token removal and redirect for analysis endpoints
      // These use optionalAuthMiddleware and should degrade gracefully
      const requestUrl = error.config?.url || '';
      if (!requestUrl.includes('/api/analysis/')) {
        // Token expired or invalid
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    if (error.response?.status === 403 && error.response?.data?.code === 'SUBSCRIPTION_REQUIRED') {
      // Trial expired and no active subscription
      if (window.location.pathname !== '/subscription-expired') {
        window.location.href = '/subscription-expired';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
